import { ImSpinner2 } from 'react-icons/im';

function Spinner({ size = 50 }: { size?: number }) {
  return (
    <ImSpinner2 className="animate-spin" size={size} />
  );
}

export default Spinner;
